export default "__VITE_ASSET__Czpm7rad__"